function StepperRight({ steps, currentStep }) {
  return (
    <>
      <div className="stepper-right">
        {steps.map((_, index) => (
          <div key={index} className="stepper-line-wrapper">
            <div className={`stepper-circle ${index === currentStep ? "active" : ""}`}>{index + 1}</div>
            {index < steps.length - 1 && <div className="stepper-line"></div>}
          </div>
        ))}
      </div>
    </>
  )
}
export default StepperRight;